import React, { useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import purify from 'dompurify';
import { Grid, Text } from 'elements';
import { RootState } from 'modules';
import { TReply } from 'modules/case/types';
import { Button } from 'antd';
import { Colors, SecondaryColor, PrimaryColor } from 'GlobalStyles';
import DefaultUser from 'assets/icons/default.webp';
import ThumbsDown from 'assets/icons/thumbsDown.svg';
import ThumbsUp from 'assets/icons/thumbsUp.svg';
import Edit from './Edit';

const ReplyItem = ({
  page_type,
  reply,
  canAddReply = true,
  onSave = () => {},
  onEdit = () => {},
  dislike,
  like,
  del,
  isSubReplies,
}: {
  page_type?: string;
  reply: TReply;
  canAddReply: boolean;
  onSave?: (args1: string) => void;
  onEdit?: (args1: string) => void;
  dislike: () => void;
  like: () => void;
  del: (replyId: number) => void;
  isSubReplies?: boolean;
}) => {
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  const [selected, setSelected] = useState<{ [key: string]: any }>();

  const nl2br = (str: string) => {
    // const stringVar = str;
    return str.replace(/\n/g, '<br />');
  };

  const callDislike = () => {
    if (reply.is_like !== false) dislike();
  };
  const callLike = () => {
    if (page_type === 'caseQNA') {
      // 싫어요는 없고 좋아요만 있기 때문에 조건없이 api 호출하는 것으로
      like();
    } else {
      if (reply.is_like !== true) like();
    }
  };
  const callSave = (body: string) => {
    if (selected && selected.id) onEdit(body);
    else onSave(body);
    setSelected(undefined);
  };

  return page_type === 'caseQNA' ? (
    <>
      <Grid gap='8px' align='center'>
        <Grid
          isInline
          image={reply.created_by.profile_image.absolute_url || DefaultUser}
          width='40px'
          height='40px'
          borderRadius='40px'
        />
        <Grid isInline>
          <Grid gap='8px' align='center'>
            <Text>{reply.created_by.fullname || '-'}</Text>
            {!!reply.is_current && (
              // <Grid isInline padding='2px 8px' backgroundColor={SecondaryColor} borderRadius='4px'>
              <Grid
                isInline
                padding='2px 8px'
                backgroundColor={reply.is_current === '시니어' ? PrimaryColor : SecondaryColor}
                borderRadius='4px'
              >
                <Text color={Colors.white} size='0.9rem'>
                  {reply.is_current}
                </Text>
              </Grid>
            )}
          </Grid>
          <Grid marginTop='3px' gap='12px' align='center'>
            <Text color={Colors.grey3} size='0.8rem'>
              {reply.created_at || '-'}
            </Text>
            {currentUser && (
              <>
                {canAddReply && (
                  <Button className='text small' onClick={() => setSelected({})}>
                    답글쓰기
                  </Button>
                )}
                {reply.created_by.id === currentUser.id && (
                  <Grid isInline>
                    <Button className='text small' onClick={() => setSelected(reply)}>
                      수정
                    </Button>
                    <Button className='text small' onClick={() => del(reply.id)}>
                      삭제
                    </Button>
                  </Grid>
                )}
              </>
            )}
            {/* 메인댓글일 때만 좋아요 할 수 있게 */}
            {!isSubReplies && (
              <Grid isInline gap='6px' align='center'>
                <Grid
                  isInline
                  image={ThumbsDown}
                  width='10px'
                  height='10px'
                  cursor='pointer'
                  onClick={callLike}
                />
                <Text color={Colors.grey3} size='0.8rem'>
                  {reply.like_count || '0'}
                </Text>
                {/* <Grid isInline image={ThumbsUp} width='10px' height='10px' cursor='pointer'
                onClick={callDislike} />
              <Text color={Colors.grey3} size='0.8rem'>{reply.dislike_count || '0'}</Text> */}
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Grid gap='8px'>
        <Text size='1.2rem'>
          <span
            dangerouslySetInnerHTML={{
              __html: purify.sanitize(nl2br(reply.content)),
            }}
          />
        </Text>
      </Grid>
      {selected && (
        <Grid marginTop='8px'>
          <Edit initBody={selected.content || ''} onSave={callSave} />
        </Grid>
      )}
    </>
  ) : (
    <>
      <Grid gap='8px' align='center'>
        <Grid
          isInline
          image={reply.profile_image || DefaultUser}
          width='40px'
          height='40px'
          borderRadius='40px'
        />
        <Grid isInline>
          <Grid gap='8px' align='center'>
            <Text>{reply.name || '-'}</Text>
            {!!reply.is_current && (
              // <Grid isInline padding='2px 8px' backgroundColor={SecondaryColor} borderRadius='4px'>
              <Grid
                isInline
                padding='2px 8px'
                backgroundColor={reply.is_current === '시니어' ? PrimaryColor : SecondaryColor}
                borderRadius='4px'
              >
                <Text color={Colors.white} size='0.9rem'>
                  {reply.is_current}
                </Text>
              </Grid>
            )}
          </Grid>
          <Grid marginTop='3px' gap='12px' align='center'>
            <Text color={Colors.grey3} size='0.8rem'>
              {reply.created_at || '-'}
            </Text>
            {currentUser && (
              <>
                {canAddReply && (
                  <Button className='text small' onClick={() => setSelected({})}>
                    답글쓰기
                  </Button>
                )}
                {reply.user_id === currentUser.id && (
                  <Grid isInline>
                    <Button className='text small' onClick={() => setSelected(reply)}>
                      수정
                    </Button>
                    <Button className='text small' onClick={() => del(reply.id)}>
                      삭제
                    </Button>
                  </Grid>
                )}
              </>
            )}
            <Grid isInline gap='6px' align='center'>
              <Grid
                isInline
                image={ThumbsDown}
                width='10px'
                height='10px'
                cursor='pointer'
                onClick={callLike}
              />
              <Text color={Colors.grey3} size='0.8rem'>
                {reply.like_count || '0'}
              </Text>
              <Grid
                isInline
                image={ThumbsUp}
                width='10px'
                height='10px'
                cursor='pointer'
                onClick={callDislike}
              />
              <Text color={Colors.grey3} size='0.8rem'>
                {reply.dislike_count || '0'}
              </Text>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid gap='8px'>
        <Text size='1.2rem'>
          <span
            dangerouslySetInnerHTML={{
              __html: purify.sanitize(nl2br(reply.content)),
            }}
          />
        </Text>
      </Grid>
      {selected && (
        <Grid marginTop='8px'>
          <Edit initBody={selected.content || ''} onSave={callSave} />
        </Grid>
      )}
    </>
  );
};

export default ReplyItem;
